import React from 'react';
import SiteHeader from './SiteHeader';
import AboutContact from './AboutContact';

const PrivacyNotice = ({ onOpenProduct }) => (
  <>
    <SiteHeader onOpenProduct={onOpenProduct} />
    <section className="q-section" data-testid="privacy-section">
      <div className="q-section__inner q-privacy">
        <div className="q-section__head">
          <span className="q-section__eyebrow">Transparencia</span>
          <h2 className="q-section__title">Aviso de Privacidad</h2>
        </div>

        <div className="q-privacy__body">
          <p>
            QUINLATE usa herramientas de analítica web (Google Analytics) para entender
            cómo se navega el sitio: qué páginas se visitan, qué productos se ven más y
            si se hace clic en los botones de WhatsApp. Esta información es estadística
            y agregada — no identifica a una persona por su nombre.
          </p>
          <p>
            No pedimos ni almacenamos contraseñas, datos de tarjetas ni información de
            pago en este sitio. Los pedidos se coordinan directamente por WhatsApp, y los
            pagos con tarjeta (cuando estén disponibles) se procesan a través de Mercado
            Pago, sujeto a su propio aviso de privacidad.
          </p>
          <p>
            Si tienes dudas sobre esta información o quieres solicitar que se eliminen tus
            datos de navegación, escríbenos por WhatsApp.
          </p>
        </div>
      </div>
    </section>
    <AboutContact />
  </>
);

export default PrivacyNotice;
